import { ColumnSortBar, FilterableList } from 'metrix-common3';
import { LIST_COLUMNS, LIST_FIELDS } from './fields';
import PolicyListItem from './Results/PolicyListItem';

const PAGE_SIZE = 25;

// One fixed width for the 12-column table at every breakpoint; the FilterableList track scrolls
// horizontally on screens narrower than this, so mobile scrolls to all columns instead of collapsing.
const ITEM_MIN_WIDTH = '2000px';

const List = (props) => {
    const { context, reference, products, listPolicies, query, showFilters, onActiveFiltersChange } = props;
    const list = query.list;

    // Products arrive as { code, name }; the shared component expects { code, value }.
    const productOptions = (products || []).map((product) => ({ code: product.code, value: product.name }));

    // Push the query into Redux (the saga's source of truth) then fetch. doReduceView keeps the
    // reducer writing under query.list before the field writes land.
    const applyQuery = (filters, page, fetch) => {
        props.doReduceView('list');
        for (const [code, value] of Object.entries(filters)) {
            props.doReduceQueryElement({ code, value });
        }
        props.doReduceQueryElement({ code: 'skip', value: (page - 1) * PAGE_SIZE });
        props.doReduceQueryElement({ code: 'take', value: PAGE_SIZE });
        fetch();
    };

    // Report whether the applied query holds any filter so the header can badge its collapse toggle.
    const runQuery = ({ filters, page, hasActiveFilters }, fetch) => {
        applyQuery(filters, page, fetch);
        onActiveFiltersChange?.(hasActiveFilters);
    };

    // Sorting is owned by the page (the sort bar is an opaque slot): set the order, reset to the
    // first page, and re-query. Toggles direction when re-clicking the active column.
    const handleSort = (columnName) => {
        props.doReduceView('list');
        props.doReduceQueryElement({ code: 'orderByFieldNames', value: [columnName] });
        props.doReduceQueryElement({
            code: 'orderByDesc',
            value: list.orderByFieldNames?.[0] === columnName ? !list.orderByDesc : true,
        });
        props.doReduceQueryElement({ code: 'skip', value: 0 });
        props.doQueryPolicies();
    };

    return (
        <FilterableList
            fields={LIST_FIELDS}
            roles={[context.session.userType]}
            references={reference.references}
            onLoadReference={(code) => reference.doGetReferences(code)}
            extras={{ products: productOptions }}
            items={listPolicies}
            keyOf={(policy) => policy.policyTransactionGuid}
            renderItem={(policy) => <PolicyListItem policy={policy} context={context} />}
            sortBar={
                <ColumnSortBar
                    columns={LIST_COLUMNS}
                    sortBy={list.orderByFieldNames?.[0]}
                    orderByDesc={list.orderByDesc}
                    onSort={handleSort}
                />
            }
            itemMinWidth={ITEM_MIN_WIDTH}
            persistKey='policies.list'
            pageSize={PAGE_SIZE}
            hasNext={listPolicies?.length === PAGE_SIZE}
            showFilters={showFilters}
            onQuery={(payload) => runQuery(payload, props.doQueryPolicies)}
            onClear={(payload) => runQuery(payload, props.doGetListPolicies)}
        />
    );
};

export default List;
